export const GET_COMMON_CODE = "admin/GET_COMMON_CODE";
export const GET_COMMON_CODE_SUCCESS = "admin/GET_COMMON_CODE_SUCCESS";
export const GET_COMMON_CODE_FAILURE = "admin/GET_COMMON_CODE_FAILURE";
